/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategorySummaryDTO } from './categorySummaryDTO';

export interface ResponseB4AListCategorySummaryDTO {
  result?: Array<CategorySummaryDTO>;
}
